import { cn } from '@/lib/utils';

interface SkeletonProps {
  className?: string;
}

function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-text-muted/20', className)}
      aria-hidden="true"
    />
  );
}

export { Skeleton };
